// Partes do pagamento que cada pedido da mesa grava ao fechar dividido
// (forma "multiplo"). O log da mesa é apagado quando ela fecha: sem as partes
// no pedido, a divisão se perdia e a tela de Pedidos só sabia dizer "Múltiplo"
// (dono, 24/09/2026 — "cada forma de pagamento que for usada deve entrar certinho").
//
// Mesa com 2+ pedidos (rodadas do Mesa QR, append): cada forma é rateada pelo
// total de cada pedido. Tudo em centavos: as partes de um pedido fecham com o
// total dele, e a soma de cada forma nos pedidos bate com o que foi cobrado.

const centavos = (v) => Math.round((Number(v) || 0) * 100);
const reais = (c) => Math.round(c) / 100;
const soma = (lista) => lista.reduce((s, v) => s + v, 0);

// Log da mesa [{code, label, value}] → uma forma por código, na ordem em que apareceu.
function formasDoLog(log) {
  const porCodigo = new Map();
  (log || []).forEach((p) => {
    // PIX do celular aprovado depois da conta quitada guarda a sobra em
    // `excedente` (é para devolver): só o resto pagou a conta
    const c = centavos(p?.value) - centavos(p?.excedente);
    if (!p?.code || c <= 0) return;
    const atual = porCodigo.get(p.code) || { method: p.code, label: p.label || p.code, c: 0 };
    atual.c += c;
    porCodigo.set(p.code, atual);
  });
  return [...porCodigo.values()];
}

// Quanto do cobrado cabe a cada pedido, proporcional ao total dele — e nunca
// mais que o total (gorjeta digitada a mais com 2+ pedidos passaria do real).
function alvosPorPedido(cobrado, totais) {
  const t = totais.map(centavos);
  const totalMesa = soma(t);
  if (totalMesa <= 0) return t.map(() => 0);
  return t.map((v) => Math.min(v, Math.round((cobrado * v) / totalMesa)));
}

/**
 * `log`: pagamentos da mesa; `totais`: total final de cada pedido aberto, na
 * ordem do PUT. Devolve, para cada pedido, [{method, label, amount}].
 */
export function partesPorPedido(log, totais) {
  const formas = formasDoLog(log);
  const cobrado = soma(formas.map((f) => f.c));
  if (!formas.length || !totais.length || cobrado <= 0) return totais.map(() => []);
  const alvos = alvosPorPedido(cobrado, totais);
  const restante = formas.map((f) => f.c);
  return totais.map((_, i) => {
    const alvo = Math.min(soma(restante), i === totais.length - 1 ? centavos(totais[i]) : alvos[i]);
    const partes = formas.map((f, j) => Math.min(restante[j], Math.round((alvo * f.c) / cobrado)));
    // Sobra ou falta de arredondamento: acerta nas formas que ainda têm saldo
    let falta = alvo - soma(partes);
    for (let j = formas.length - 1; j >= 0 && falta !== 0; j--) {
      const ajuste = falta > 0 ? Math.min(falta, restante[j] - partes[j]) : Math.max(falta, -partes[j]);
      partes[j] += ajuste;
      falta -= ajuste;
    }
    partes.forEach((c, j) => { restante[j] -= c; });
    return formas
      .map((f, j) => ({ method: f.method, label: f.label, amount: reais(partes[j]) }))
      .filter((p) => p.amount > 0);
  });
}
